import { createContext } from "react";

interface SignAndLockValidationErrorsContextOptions {
  signAndLockValidationErrors: Record<string, string>;
  setSignAndLockValidationErrors: (errors: Record<string, string>) => void;
  clearSignAndLockValidationErrors: () => void;
}

export const SignAndLockValidationErrorsContext =
  createContext<SignAndLockValidationErrorsContextOptions>({
    signAndLockValidationErrors: {},
    setSignAndLockValidationErrors: () => null,
    clearSignAndLockValidationErrors: () => null,
  });
